// Same payee as the current pujoassistant.online QR.
export const UPI = {
  vpa: 'MSONE10UTSAVCOMMITTEE.eazypay@icici',
  payee: 'M/S.ONE 10 UTSAV COMMITTEE',
  tr: 'EZYS9163226065',
};

/**
 * UPI intent link. Amount and order note are only added when the admin turns on
 * "Amount in UPI QR" after testing it with GPay, PhonePe and Paytm on the eazypay VPA.
 */
export function upiLink(amount: number, orderCode: string, includeAmount: boolean): string {
  const params = new URLSearchParams({ pa: UPI.vpa, pn: UPI.payee, tr: UPI.tr, cu: 'INR' });
  if (includeAmount) {
    params.set('am', amount.toFixed(2));
    params.set('tn', orderCode);
  }
  return 'upi://pay?' + params.toString().replace(/\+/g, '%20');
}
